(() => {
  const HANDLE = '2-in-1-portable-pet-hair-dryer-grooming-brush';
  if (!location.pathname.includes(`/products/${HANDLE}`)) return;

  const messages = {
    'Oneclick hair removal golden': 'Golden finish with one-click hair release and a US plug.',
    'Oneclick hair removal green': 'Green finish with one-click hair release and a US plug.',
    'Oneclick hair removal greenSet': 'Green Set configuration with one-click hair release and a US plug.',
    'Oneclick hair removal pink': 'Pink finish with one-click hair release and a US plug.'
  };

  function colorFieldset(root) {
    const input = root.querySelector('input[data-option-name="Color" i], input[name^="Color-" i]');
    return input?.closest('fieldset') || null;
  }

  function update(root) {
    const fieldset = colorFieldset(root);
    if (!fieldset) return;
    let note = root.querySelector('[data-pc-hair-dryer-note]');
    if (!note) {
      note = document.createElement('div');
      note.className = 'pc-hair-dryer-note';
      note.dataset.pcHairDryerNote = '';
      note.setAttribute('role', 'status');
      note.setAttribute('aria-live', 'polite');
      fieldset.insertAdjacentElement('afterend', note);
    }
    const selected = fieldset.querySelector('input:checked')?.value || '';
    const next = messages[selected] || '';
    if (note.textContent !== next) note.textContent = next;
    note.hidden = !next;
  }

  function init() {
    document.querySelectorAll('product-info').forEach((root) => {
      if (root.dataset.pcHairDryerNoteReady === 'true') return;
      if (!colorFieldset(root)) return;
      root.dataset.pcHairDryerNoteReady = 'true';
      root.addEventListener('change', (event) => {
        if (event.target.matches('input[data-option-name="Color" i], input[name^="Color-" i]')) update(root);
      });
      new MutationObserver(() => requestAnimationFrame(() => update(root)))
        .observe(root, { childList: true, subtree: true });
      update(root);
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  init();
})();
